/**
 * Barcode label header/footer display options.
 *
 * Persisted to Mongo — keep in sync with the `typedEnum` registration in
 * `redo/backend/db/schema/src/team/ProductSettings.ts`.
 */
export enum BARCODE_HEADER_FOOTER_OPTIONS {
  UPC = "upc",
  PRODUCT_VARIANT_NAME = "product-variant-name",
  PRODUCT_OVER_SKU = "product-over-sku",
  SKU_AND_WAREHOUSE = "sku-and-warehouse",
  SKU_ONLY = "sku-only",
  WAREHOUSE_ONLY = "warehouse-only",
  NONE = "none",
}
